export var subscription_table = {
  data() {
    return {
      headers: [
        {
          text: this.$t("thead.subscription_name"),
          value: "subscription.name",
          search_type: "text"
        },
        {
          text: this.$t("thead.license_plate"),
          value: "license_plate",
          search_type: "text"
        },
        {
          text: this.$t("thead.license_plate_country_code"),
          value: "license_plate_country_code",
          search_type: "text"
        },
        {
          text: this.$t("thead.start_date"),
          value: "subscription_start_date",
          renderer: "date",
          search_type: "text"
        },
        {
          text: this.$t("thead.end_date"),
          value: "subscription_end_date",
          renderer: "date",
          search_type: "text"
        },
        {
          text: this.$t("thead.active"),
          value: "active",
          renderer: "boolean",
          sortable: false,
          align: "center"
        }
      ]
    };
  }
};

export const subscription_create = {
  data() {
    return {
      valid: false,
      form: {
        license_plate: {
          license_plate: null,
          license_plate_country_code: null
        }
      }
    };
  }
};
